<!-- eslint-disable vuejs-accessibility/click-events-have-key-events -->
<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4" style="max-width: 400px">
        <v-card
          v-if="!loadingValidate"
          shaped
          class="elevation-24"
          :style="{ 'border-bottom-right-radius': '0px' }"
        >
          <v-list-item class="pt-6">
            <v-list-item-content>
              <v-img src="@/assets/logo-bni-qris.webp" max-width="8rem"></v-img>

              <h2 class="mt-4 font-weight-black">Ubah Email</h2>
            </v-list-item-content>
          </v-list-item>
          <v-card-text style="padding-bottom: 4px">
            <div class="grey--text text-justify">
              Untuk melanjutkan proses perubahan email, silakan masukkan alamat
              email baru. Email yang terdaftar sebelumnya akan diganti setelah
              proses verifikasi berhasil diselesaikan. Link verifikasi akan
              dikirimkan ke email baru yang Anda input.
            </div>
            <v-form ref="form" lazy-validation v-on:submit.prevent="">
              <v-text-field
                :hint="hint"
                persistent-hint
                label="Email Baru"
                name="email"
                prepend-icon="mdi-email"
                type="text"
                v-model="email"
                v-on:keyup.enter="submitEmail"
                :error-messages="emailErrors"
                @change="$v.email.$touch()"
                @blur="$v.email.$touch()"
              />
            </v-form>
          </v-card-text>
          <v-card-actions
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 8px 16px 16px 16px;
            "
          >
            <v-btn
              color="orange"
              @click="back"
              :disabled="loading"
              style="color: white"
              >Back</v-btn
            >
            <v-btn
              color="#005f7a"
              style="color: white"
              @click="submitEmail"
              :disabled="loading || timer > 1"
              >Send</v-btn
            >
          </v-card-actions>
          <v-progress-linear
            :active="loading"
            :indeterminate="loading"
            absolute
            bottom
            color="red lighten-2"
          />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { email } from 'vuelidate/lib/validators';
import { date } from '@/lib/helpers';
import { resendEmail } from '../store/params';

export default {
  name: 'ChangeEmail',
  mixins: [validationMixin],
  validations: {
    email: {
      required(value) {
        return value != '';
      },
      email,
    },
  },
  mounted() {
    if (this.$route.name == 'ChangeEmail') {
      if (
        this.$route.params.token != '' &&
        this.$route.params.token != null
      ) {
        this.validateToken();
      }
    }
  },
  data() {
    return {
      loadingValidate: false,
      email: '',
      validToken: false,
      timer: 0,
      emailChanged: false,
      resendEmail,
    };
  },
  computed: {
    loading() {
      return this.$store.state.loading;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      if (!this.$v.email.required) errors.push('Email baru harus diisi');
      if (!this.$v.email.email) errors.push('Harus berupa email yang valid');
      return errors;
    },
    hint() {
      const second = `0${(this.timer % 60).toString()}`.slice(-2);
      const minute = `0${Math.floor(this.timer / 60).toString()}`.slice(-2);
      return this.timer == 0
        ? ''
        : `Kirim ulang dalam ${minute}:${second}`;
    },
  },

  methods: {
    async validateToken() {
      this.loadingValidate = true;
      let { token } = this.$route.params;
      token = token.replace(/-/g, '+');
      token = token.replace(/_/g, '/');
      
      try {
        await this.$store
          .dispatch('validateChangeEmailToken', {
            token,
            date,
          })
          .then((res) => {
            if (res && res.expired && res.code === 419) {
              this.$router.push('/login');
            } else if (res) {
              this.validToken = true;
              this.loadingValidate = false;
            }
          });
      } catch (error) {
        console.error('Error validating token:', error);
        this.$router.push('/login');
      }
    },

    async submitEmail() {
      this.$v.$touch();
      if (!this.$v.$invalid && !this.loading && this.timer < 1) {
        this.$store
          .dispatch('submitChangeEmail', {
            new_email: this.email,
            date,
          })
          .then(({ expired, code } = {}) => {
            if (expired && code === 419) {
              setTimeout(() => {
                this.$router.push('/login');
              }, 2000);
            }
            if (code === 200) {
              setTimeout(() => {
                this.$router.push('/login');
              }, 1500);
            }
          })
          .finally(() => {
            this.$store.commit('setLoading', false);
          });
      }
    },

    back() {
      this.$router.push('/login');
    },
  },
};
</script>

<style scoped>
.border-top {
  border-radius: 24px 0px 0px 0px;
}
.header-logo {
  align-self: flex-start;
  position: absolute;
  left: 0;
  top: 0;
}
</style>
